module.exports = __webpack_public_path__ + "static/media/ivy.32597db3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ivy.svg
// module id = 190
// module chunks = 0